module.exports = __webpack_public_path__ + "static/img/fabrication_4.f84adff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrication_4.jpg
// module id = r7a8
// module chunks = 0